export default "__VITE_ASSET__6bdf3c82__"